import { Modal } from '@material-ui/core';
import MyButton from 'components/form/MyButton';
import React from 'react';
import { isMobile } from 'react-device-detect';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { Form, TextArea } from 'semantic-ui-react';

const DisplayReturnCommand = ({ open, setOpen, titre, text }) => {

  const handleOnClose = (reason) => {
    if (reason !== 'backdropClick') {
      setOpen(false);
    }
  };

  return (
    <Modal open={open} onClose={(e, reason) => handleOnClose(reason)} style={{ display: 'flex'}} disableEscapeKeyDown={true}>
      <div className="my-modal">
        <div className="row-center">
          <div style={{ width: '50%', display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>
            <h3 style={{ textTransform: 'uppercase', color: '#27313c', fontSize: isMobile ? '3.5vw' : '1vw' }}>{titre}</h3>
          </div>
          <div style={{ width: '50%', display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
            <MyButton
              className="classic-button btn-default color-fond-vert"
              type="button"
              labelImportant="Fermer"
              href="#"
              iconLeft={{ icon: faTimes, type: 'fontAwesome' }}
              styleCss={{ fontSize: isMobile ? '2vw' : '0.8vw' }}
              onClick={handleOnClose}
            />
          </div>
        </div>

        <div className="row" style={{ height: 'calc(100% - 20px)'}}>
          <Form style={{ width: '100%', height: '100%' }}>
            <TextArea value={text} style={{ height: '100%' }} />
          </Form>
        </div>

      </div>
    </Modal>
  );

};

export default DisplayReturnCommand;